import {Injectable} from '@angular/core';

@Injectable()
export class ConfigService {
    private data: Object = {};

    /**
     * @constructor
     * @description
     * Service de stockage des valeurs de configuration
     *
     */
    constructor() {
    };

    /**
     * @name put
     * @description Ajoute une clé,valeur
     * @param {string} key La clé
     * @param {any} value La valeur
     * @param {boolean} override Flag d'écrasement
     */
    public put(key: string, value: any) {
        this.data[key] = value;
    }

    /**
     * @name get
     * @description Lit la valeur d'une clé
     * @param {string} key La clé
     */
    public get(key: string) {
        if (typeof this.data[key] == 'undefined')
            console.warn('parameter "' + key + '" no found.');

        return this.data[key];
    }

    public getUserOption(option: string) { // to externalize
        let key: string = 'userGeoLim'; // to change
        if(!this.data[key])
            return null;
  
        if(typeof this.data[key][option] != 'undefined')
            return this.data[key][option];

        this.data[key][option] = null;
        for (let parameter of this.data[key] as Array<any>) {
            if (parameter["champ"] === option){
                // If several languages for user are defined, use the first one
                this.data[key][option] = parameter["value"];
                return parameter["value"];
            }
        }
        return null;
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/services/config.service.ts